module.exports = __webpack_public_path__ + "static/media/daily-hero-desktop.f647f738.jpg";